(function () {
  var selectorRoot = '[data-product-card-selector]';

  function parseVariants(root) {
    if (root._productCardVariants) return root._productCardVariants;

    var data = root.querySelector('[data-product-card-variants]');
    if (!data) return [];

    try {
      root._productCardVariants = JSON.parse(data.textContent);
    } catch (error) {
      root._productCardVariants = [];
    }

    return root._productCardVariants;
  }

  function getSelectedOptions(root) {
    return Array.from(root.querySelectorAll('[data-option-index]')).map(function (group) {
      var selectedPill = group.querySelector('[data-option-value][aria-pressed="true"]');
      var select = group.querySelector('[data-option-select]');
      var single = group.querySelector('.ae--product-card-selector__single');

      if (selectedPill) return selectedPill.dataset.optionValue;
      if (select) return select.value;
      return single ? (single.dataset.optionValue || single.textContent.trim()) : '';
    });
  }

  function setSelectedOptions(root, options) {
    root.querySelectorAll('[data-option-index]').forEach(function (group) {
      var index = Number(group.dataset.optionIndex);
      var value = options[index];
      var select = group.querySelector('[data-option-select]');

      group.querySelectorAll('[data-option-value]').forEach(function (button) {
        var selected = button.dataset.optionValue === value;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        if (selected) {
          button.dataset.servingTone = getServingTone(button.textContent.trim()) || getServingTone(value);
        } else {
          delete button.dataset.servingTone;
        }
      });

      // Single-value size options render a static pill that still needs a tone.
      var single = group.querySelector('.ae--product-card-selector__single');
      if (single) single.dataset.servingTone = getServingTone(single.textContent.trim()) || getServingTone(single.dataset.optionValue);

      if (select) select.value = value;
    });
  }

  // Resolves a pill label to a serving identity used by card styling. Twelve-pack
  // cans have their own identity so they are not confused with the 12oz tone.
  function getServingTone(value) {
    var normalized = String(value || '').toLowerCase();
    if (/stick|byo|build your own|single serving/.test(normalized)) return 'byo';
    // Build Your Own is the only pill shown as a count range (e.g. "6-15").
    if (/\d+\s*-\s*\d+/.test(normalized)) return 'byo';
    var oz = normalized.match(/(\d+(?:\.\d+)?)\s*oz/);
    if (oz) return Number(oz[1]) <= 14 ? '12-oz' : '16-oz';

    if (/12\s*-?\s*pack/.test(normalized)) return '12-pack';

    var servings = normalized.match(/\d+/);
    if (servings) {
      var count = Number(servings[0]);
      if (count === 8) return '8';
      if (count === 15) return '15';
      if (count < 15) return '10';
      if (count <= 25) return '20';
      return '30';
    }

    return '';
  }

  function getServingToneFromOptions(options, root) {
    var fallback = '';
    var packTone = '';
    var ounceTone = '';
    var list = (options || []).slice();

    // Some products store a bare value such as "12" and use the product's
    // Servings Label metafield to render "12 Pack". Include those rendered
    // labels so pack identity is not lost when resolving the card tone.
    if (root) {
      root.querySelectorAll('[data-option-index]').forEach(function (group) {
        var selected = group.querySelector('[data-option-value][aria-pressed="true"], .ae--product-card-selector__single');
        if (selected) list.push(selected.textContent.trim());
      });
    }

    for (var i = 0; i < list.length; i += 1) {
      var tone = getServingTone(list[i]);
      if (!ounceTone && (tone === '12-oz' || tone === '16-oz')) ounceTone = tone;
      if (!packTone && tone === '12-pack') packTone = tone;
      if (!fallback && tone) fallback = tone;
    }

    if (ounceTone === '12-oz' && isEnergyDrinkCard(root?.closest('.ae--product-card'))) return '16-oz';
    return ounceTone || packTone || fallback;
  }

  function isEnergyDrinkCard(card) {
    return card && card.classList.contains('ae--product-card--plpb') && /energy/i.test(`${card.dataset.eaTags || ''} ${card.dataset.eaProductType || ''}`);
  }

  function getServingValues(options, root) {
    var values = (options || []).slice();
    if (root) {
      root.querySelectorAll('[data-option-index]').forEach(function (group) {
        var selected = group.querySelector('[data-option-value][aria-pressed="true"], .ae--product-card-selector__single');
        if (selected) values.push(selected.textContent.trim());
      });
    }
    return values;
  }

  function getServings(options, root) {
    var values = getServingValues(options, root);
    for (var i = 0; i < values.length; i += 1) {
      var match = String(values[i] || '').match(/\d+/);
      if (match) return Number(match[0]);
    }
    return 0;
  }

  // Physical size ladder: smaller packs read smaller than the 30-serving hero.
  function getServingLadder(servings) {
    if (!servings) return 1;
    var base = Math.max(0.8, Math.min(1, Math.cbrt(servings / 30)));
    var scaled = servings < 30 ? Math.min(1, base * 1.21) : base;
    return scaled * (servings === 10 ? 0.894 : 1);
  }

  // Measures the opaque (alpha) bounds of a product PNG once per URL so scaling
  // ignores transparent padding — a padded image is sized like a trimmed one.
  var alphaCache = {};
  function measureAlpha(url) {
    if (alphaCache[url]) return alphaCache[url];

    var entry = { pad: 0, cw: 1, ch: 1, nw: 0, nh: 0, ready: false, callbacks: [] };
    alphaCache[url] = entry;

    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      // Keep the exact dimensions of the measured URL so geometry is computed
      // from the same image the alpha bounds came from (not the display img,
      // which may be a different srcset width or mid-swap during a variant change).
      entry.nw = probe.naturalWidth;
      entry.nh = probe.naturalHeight;
      try {
        var size = 256;
        var canvas = document.createElement('canvas');
        canvas.width = size;
        canvas.height = size;
        var context = canvas.getContext('2d', { willReadFrequently: true });
        context.drawImage(probe, 0, 0, size, size);
        var data = context.getImageData(0, 0, size, size).data;
        var top = size;
        var bottom = -1;
        var left = size;
        var right = -1;

        for (var y = 0; y < size; y += 1) {
          for (var x = 0; x < size; x += 1) {
            if (data[(y * size + x) * 4 + 3] > 48) {
              if (y < top) top = y;
              if (y > bottom) bottom = y;
              if (x < left) left = x;
              if (x > right) right = x;
            }
          }
        }

        if (bottom >= 0) {
          entry.pad = (size - 1 - bottom) / size;
          entry.cw = (right - left + 1) / size;
          entry.ch = (bottom - top + 1) / size;
        }
      } catch (error) {
        // Cross-origin taint or decode failure: fall back to full-frame bounds.
      }

      entry.ready = true;
      entry.callbacks.splice(0).forEach(function (callback) { callback(); });
    };
    probe.onerror = function () {
      entry.ready = true;
      entry.callbacks.splice(0).forEach(function (callback) { callback(); });
    };
    probe.src = url;

    return entry;
  }

  // Scales the visible (alpha-trimmed) product to fill the target zone, then
  // shifts it down so its base sits on the pill-rail tuck line. Uses the fixed
  // 4:5 zone aspect (not live pixels) so the result is identical every load.
  function computeImageGeometry(container, naturalWidth, naturalHeight, alpha, options) {
    if (!naturalWidth || !naturalHeight) return null;

    // Unit zone in the card's fixed 4:5 aspect; absolute size cancels out.
    var zoneWidth = 4;
    var zoneHeight = 5;

    var containWidth = Math.min(zoneWidth, zoneHeight * (naturalWidth / naturalHeight));
    var containHeight = Math.min(zoneHeight, zoneWidth * (naturalHeight / naturalWidth));
    var visibleWidthFrac = alpha && alpha.ready ? alpha.cw : 1;
    var visibleHeightFrac = alpha && alpha.ready ? alpha.ch : 1;
    var bottomPadFrac = alpha && alpha.ready ? alpha.pad : 0;

    var visibleWidth = Math.max(0.001, visibleWidthFrac * containWidth);
    var visibleHeight = Math.max(0.001, visibleHeightFrac * containHeight);

    var selector = container.closest('.ae--product-card') && container.closest('.ae--product-card').querySelector(selectorRoot);
    var tone = getServingToneFromOptions(options, selector);

    // A product can store pack count and ounces as separate options. Resolve
    // physical can height from the explicit ounce value when one is present.
    var canOunceTone = '';
    options.some(function (option) {
      var match = String(option || '').toLowerCase().match(/(\d+(?:\.\d+)?)\s*oz/);
      if (!match) return false;
      canOunceTone = Number(match[1]) <= 14 ? '12-oz' : '16-oz';
      return true;
    });

    var scale;
    if (tone === '12-oz' || tone === '16-oz' || tone === '12-pack') {
      // RTD cans (spec §5.2): target the canonical drawn height (16oz 0.844,
      // 12oz 0.6716) × global 0.92 so a 12oz reads proportionally shorter than a
      // 16oz. Cap by the zone width so wide multi-can pack shots (same oz tone)
      // contain instead of overflowing. Whitespace is already alpha-trimmed.
      var canHeightFrac = (canOunceTone || tone) === '16-oz' ? 0.844 : 0.6716;
      var canCard = container.closest('.ae--product-card');
      var canImageBoost = canCard && canCard.classList.contains('ae--product-card--plpb') ? 1.25 : 1;
      if (document.body.classList.contains('plpb-multi-drinks-energy')) canImageBoost = 1;
      // Energy drinks use the 16oz visual treatment, retaining their actual size label.
      if (isEnergyDrinkCard(canCard)) canHeightFrac = 0.844;
      var canHeightScale = ((canHeightFrac * zoneHeight) / visibleHeight) * 0.92 * canImageBoost;
      var canWidthCap = (0.92 * zoneWidth) / visibleWidth;
      scale = Math.max(0.25, Math.min(canHeightScale, canWidthCap));
    } else {
      var fill = Math.min((0.88 * zoneHeight) / visibleHeight, (0.92 * zoneWidth) / visibleWidth);
      // Give the full-size 30-serving bags a small visual lift while preserving
      // the relative size ladder for 10- and 20-serving packages.
      var bagScale = tone === '30' ? 1.02 : 1;
      var bagCard = container.closest('.ae--product-card');
      var bagSelector = bagCard && bagCard.querySelector(selectorRoot);
      var servings = getServings(options, bagSelector);
      var isTenServingBag = servings === 10 && getServingValues(options, bagSelector).some(function (option) {
        return /\bbag\b/i.test(String(option || ''));
      });
      if (isTenServingBag && bagCard && bagCard.classList.contains('ae--product-card--plpb')) {
        bagScale *= 1.12;
      }
      scale = Math.max(0.25, fill * getServingLadder(servings) * bagScale);
    }

    // Extra tuck behind the pill rail, as a fraction of zone height.
    var seatFrac = tone === '30' ? 0.01 : tone === '20' ? 0.02 : tone === '15' ? 0.06 : tone === '10' ? 0.1 : tone === 'byo' ? 0.03 : 0.02;

    var transparentBottomFrac = (bottomPadFrac * containHeight * scale) / zoneHeight;
    var padShift = (transparentBottomFrac + seatFrac) * 100;

    return { scale: scale.toFixed(3), padShift: padShift.toFixed(2) + '%' };
  }


  function findVariant(variants, options) {
    return variants.find(function (variant) {
      return variant.options.every(function (value, index) {
        return value === options[index];
      });
    });
  }

  function findFallbackVariant(variants, changedIndex, changedValue) {
    return variants.find(function (variant) {
      return variant.options[changedIndex] === changedValue && variant.available;
    }) || variants.find(function (variant) {
      return variant.options[changedIndex] === changedValue;
    });
  }

  function formatMoney(cents) {
    if (typeof window.formatMoney === 'function') {
      return window.formatMoney(cents, window.moneyFormat || '${{amount}}');
    }

    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(cents / 100);
  }

  function updatePrice(card, root, variant) {
    var price = card.querySelector('.ae--product-card-price, .comparing-prices');
    if (!price || price.querySelector('.current-price-pdp-variety-pack')) return;

    var productId = root.dataset.productId;
    var compareAtPrice = Number(variant.compareAtPrice || 0);
    var currentPrice = Number(variant.price || 0);
    var wrapper;

    if (price.classList.contains('comparing-prices')) {
      wrapper = price;
    } else {
      wrapper = document.createElement('div');
      price.replaceWith(wrapper);
    }

    wrapper.className = compareAtPrice > currentPrice ? 'comparing-prices' : 'ae--product-card-price';
    wrapper.dataset.productId = productId;
    wrapper.dataset.variantId = variant.id;
    wrapper.dataset.originalPrice = currentPrice;
    wrapper.removeAttribute('data-ea-applied');

    if (compareAtPrice > currentPrice) {
      wrapper.innerHTML = '<p class="ae--product-card-price compare-at-price">' + formatMoney(compareAtPrice) + '</p>&nbsp;<p class="ae--product-card-price current-price">' + formatMoney(currentPrice) + '</p>';
    } else {
      wrapper.textContent = formatMoney(currentPrice);
    }
  }

  function updateDiscountBadge(card, variant) {
    var badge = card.querySelector('[data-variant-discount-badge]');
    if (!badge) return;

    var text = badge.querySelector('[data-variant-discount-text]');
    var compareAtPrice = Number(variant.compareAtPrice || 0);
    var currentPrice = Number(variant.price || 0);
    var fallback = badge.dataset.saleFallback || '';

    if (compareAtPrice > currentPrice && compareAtPrice > 0) {
      var percentage = Math.round(((compareAtPrice - currentPrice) * 100) / compareAtPrice);
      if (text) text.textContent = percentage + '% Off';
      badge.hidden = false;
      return;
    }

    if (text) text.textContent = fallback;
    badge.hidden = fallback === '';
  }

  // Tags a card image with classes + a data attribute for the selected size, so
  // the size can be targeted in CSS (e.g. .pcard-size-16oz / [data-variant-size]).
  function applyVariantSizeClass(image, options) {
    var list = options || [];
    var card = image.closest('.ae--product-card');
    var root = card && card.querySelector(selectorRoot);
    var tone = getServingToneFromOptions(list, root);
    var isFifteenServingBag = tone === '15' && card && card.classList.contains('ae--product-card--plpb');
    var sizeValue = '';
    list.some(function (option) {
      var resolved = getServingTone(option);
      if (resolved === tone) { sizeValue = option; return true; }
      return false;
    });
    if (!sizeValue && list.length) sizeValue = list[0];

    Array.prototype.slice.call(image.classList).forEach(function (cls) {
      if (cls.indexOf('pcard-size-') === 0) image.classList.remove(cls);
    });

    if (tone) {
      image.classList.add(tone === '12-oz' || tone === '16-oz' ? 'pcard-size-' + tone.replace('-', '') : 'pcard-size-' + tone);
    }
    image.classList.toggle('ae--product-card-image--15-serving-bag', isFifteenServingBag);
    image.classList.toggle(
      'ae--product-card-image--alpha-crop',
      isFifteenServingBag || image.classList.contains('ae--product-card-image--static-alpha-crop')
    );
    if (sizeValue) {
      image.dataset.variantSize = sizeValue;
      var slug = sizeValue.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
      if (getServingTone(sizeValue) === '12-oz' && tone === '16-oz') slug = '16oz';
      if (slug) image.classList.add('pcard-size-' + slug);
    } else {
      delete image.dataset.variantSize;
    }
  }

  // Sizes a card image from its measured alpha bounds. Runs for every card
  // image (single-variant and multi-variant), and again on each variant swap.
  function sizeProductImage(image, options, explicitUrl, onGeometryApplied) {
    var container = image && image.closest('.image-container');
    if (!container) return;
    // Prefer an explicit URL (from a variant swap) over currentSrc, which can
    // still point at the previous image for a tick after image.src is set.
    var url = explicitUrl || image.currentSrc || image.src;
    if (!url) return;

    applyVariantSizeClass(image, options);
    prepareAlphaCroppedCardImage(image, url);

    var alpha = measureAlpha(url);
    var token = (container._productCardSizeToken || 0) + 1;
    container._productCardSizeToken = token;
    var revealed = false;
    var notified = false;

    // Reveal only after geometry is set, so a card never flashes at the
    // unsized CSS default (scale 1) before its alpha measurement lands.
    function reveal() {
      if (container._productCardSizeToken !== token || revealed) return;
      revealed = true;
      image.dataset.productCardReady = 'true';
    }

    // Applies geometry and reveals. Waits for the alpha probe (returns false)
    // so a can is never revealed at the fallback (untrimmed) scale, and uses the
    // probe's own dimensions so the result is identical on load and on switch.
    function apply() {
      if (container._productCardSizeToken !== token) return true;
      if (!alpha.ready) return false;
      var nw = alpha.nw || image.naturalWidth;
      var nh = alpha.nh || image.naturalHeight;
      var geometry = computeImageGeometry(container, nw, nh, alpha, options || []);
      if (!geometry) return false;
      if (image.classList.contains('ae--product-card-image--alpha-crop') && image.dataset.productCardAlphaCropped === 'true') {
        geometry.scale = '1.000';
        geometry.padShift = '3%';
      }
      image.style.setProperty('--img-scale-x', geometry.scale);
      image.style.setProperty('--img-scale-y', geometry.scale);
      image.style.setProperty('--img-pad-shift', geometry.padShift);
      if (!notified && typeof onGeometryApplied === 'function') {
        notified = true;
        onGeometryApplied();
      }
      reveal();
      return true;
    }

    // Runs apply; if the alpha probe has not resolved yet, retries when it does
    // so every card ends up sized from real trimmed bounds, never the fallback.
    function tryApply() {
      if (container._productCardSizeToken !== token) return;
      if (apply()) return;
      if (!alpha.ready) { alpha.callbacks.push(tryApply); return; }
      image.addEventListener('load', tryApply, { once: true });
    }

    function whenReady() {
      if (alpha.ready) tryApply();
      else {
        alpha.callbacks.push(tryApply);
        // Safety net for a probe that never fires load/error: force the entry
        // ready (full-frame bounds + display dims) so a card is never left
        // hidden. Normal loads and errors resolve well before this.
        setTimeout(function () {
          if (revealed || container._productCardSizeToken !== token) return;
          if (!alpha.ready) {
            alpha.ready = true;
            alpha.nw = alpha.nw || image.naturalWidth;
            alpha.nh = alpha.nh || image.naturalHeight;
          }
          tryApply();
        }, 1500);
      }
    }

    whenReady();
  }

  function updateImage(card, variant, onGeometryApplied) {
    var image = card.querySelector('.ae--product-card-image');
    var container = image && image.closest('.image-container');
    if (!image || !container) return;

    var requestToken = (container._productCardImageRequest || 0) + 1;
    container._productCardImageRequest = requestToken;

    function applyCurrentImage(explicitUrl) {
      sizeProductImage(image, variant.options, explicitUrl, function () {
        if (container._productCardImageRequest !== requestToken) return;
        if (typeof onGeometryApplied === 'function') onGeometryApplied();
      });
    }

    // No variant-specific image: size the current image with this variant's options.
    if (!variant.image) {
      applyCurrentImage();
      return;
    }

    var url = variant.image;

    if (image.currentSrc === url || image.src === url) {
      applyCurrentImage(url);
      return;
    }

    // Prepare both the decoded image and its alpha geometry before committing.
    // The backdrop tone and image transform can then start in the same frame.
    var alpha = measureAlpha(url);
    var imageLoaded = false;
    var committed = false;

    function commitImage() {
      if (committed || !imageLoaded || !alpha.ready || container._productCardImageRequest !== requestToken) return;
      committed = true;
      image.src = url;
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      applyCurrentImage(url);
    }

    if (!alpha.ready) alpha.callbacks.push(commitImage);

    var preloadedImage = new Image();
    preloadedImage.crossOrigin = 'anonymous';
    preloadedImage.onload = function () {
      imageLoaded = true;
      commitImage();
    };
    preloadedImage.onerror = function () {
      if (container._productCardImageRequest !== requestToken) return;
      applyCurrentImage();
    };
    preloadedImage.src = url;
  }

  // Sizes every product-card image in scope, using the selected variant options
  // when a selector exists, so single-variant cards get alpha sizing too.
  function initProductImages(scope) {
    var images = scope.querySelectorAll ? scope.querySelectorAll('.ae--product-card .ae--product-card-image') : [];
    Array.prototype.forEach.call(images, function (image) {
      if (image.dataset.productCardSized === 'true') return;
      var card = image.closest('.ae--product-card');
      var root = card && card.querySelector(selectorRoot);
      // Cards with an initialized selector are sized by applyVariant/updateImage,
      // so skip them here to avoid a second, differently-sourced measurement.
      if (root && root.dataset.variantSelectorInitialized === 'true') return;
      image.dataset.productCardSized = 'true';
      var options = root ? getSelectedOptions(root) : [];
      sizeProductImage(image, options);
    });
  }

  function initAlphaCroppedCardImages(scope) {
    var images = [];
    if (scope.matches && scope.matches('.ae--product-card-image--alpha-crop')) images.push(scope);
    if (scope.querySelectorAll) {
      images = images.concat(Array.prototype.slice.call(scope.querySelectorAll('.ae--product-card-image--alpha-crop')));
    }

    images.forEach(function (image) {
      if (image.dataset.productCardAlphaCropBound === 'true') return;
      image.dataset.productCardAlphaCropBound = 'true';

      function cropImage() {
        var sourceUrl = image.dataset.productCardAlphaCropSource || image.currentSrc || image.src;
        if (!sourceUrl || image.dataset.productCardAlphaCropped === 'true') return;

        var probe = new Image();
        probe.crossOrigin = 'anonymous';
        probe.onload = function () {
          if (image.dataset.productCardAlphaCropSource && image.dataset.productCardAlphaCropSource !== sourceUrl) return;
          var sampleScale = Math.min(1, 960 / Math.max(probe.naturalWidth, probe.naturalHeight));
          var source = document.createElement('canvas');
          source.width = Math.max(1, Math.round(probe.naturalWidth * sampleScale));
          source.height = Math.max(1, Math.round(probe.naturalHeight * sampleScale));
          var context = source.getContext('2d', { willReadFrequently: true });
          if (!context) {
            image.dataset.productCardAlphaCropFailed = 'true';
            image.dataset.productCardReady = 'true';
            return;
          }

          try {
            context.drawImage(probe, 0, 0, source.width, source.height);
            var pixels = context.getImageData(0, 0, source.width, source.height).data;
            var left = source.width;
            var top = source.height;
            var right = -1;
            var bottom = -1;

            for (var y = 0; y < source.height; y += 1) {
              for (var x = 0; x < source.width; x += 1) {
                if (pixels[((y * source.width + x) * 4) + 3] <= 8) continue;
                left = Math.min(left, x);
                top = Math.min(top, y);
                right = Math.max(right, x);
                bottom = Math.max(bottom, y);
              }
            }

            if (right < left || bottom < top) {
              image.dataset.productCardAlphaCropFailed = 'true';
              image.dataset.productCardReady = 'true';
              return;
            }
            var padding = Math.max(1, Math.round(Math.max(source.width, source.height) * 0.01));
            left = Math.max(0, left - padding);
            top = Math.max(0, top - padding);
            right = Math.min(source.width - 1, right + padding);
            bottom = Math.min(source.height - 1, bottom + padding);
            var width = right - left + 1;
            var height = bottom - top + 1;
            if (width === source.width && height === source.height) {
              image.dataset.productCardAlphaCropFailed = 'true';
              image.dataset.productCardReady = 'true';
              return;
            }

            var cropped = document.createElement('canvas');
            cropped.width = width;
            cropped.height = height;
            var croppedContext = cropped.getContext('2d');
            if (!croppedContext) {
              image.dataset.productCardAlphaCropFailed = 'true';
              image.dataset.productCardReady = 'true';
              return;
            }
            croppedContext.drawImage(source, left, top, width, height, 0, 0, width, height);
            cropped.toBlob(function (blob) {
              if (!blob || !image.isConnected ||
                  (image.dataset.productCardAlphaCropSource && image.dataset.productCardAlphaCropSource !== sourceUrl)) return;
              var objectUrl = URL.createObjectURL(blob);
              image.removeAttribute('srcset');
              image.removeAttribute('sizes');
              image.src = objectUrl;
              image.dataset.productCardAlphaCropUrl = objectUrl;
              image.dataset.productCardAlphaCropped = 'true';
              image.dataset.productCardReady = 'true';
              image.style.setProperty('--img-scale-x', '1');
              image.style.setProperty('--img-scale-y', '1');
              image.style.setProperty('--img-pad-shift', '3%');
            }, 'image/png');
          } catch (error) {
            if (image.dataset.productCardAlphaCropSource && image.dataset.productCardAlphaCropSource !== sourceUrl) return;
            image.dataset.productCardAlphaCropFailed = 'true';
            image.dataset.productCardReady = 'true';
          }
        };
        probe.onerror = function () {
          if (image.dataset.productCardAlphaCropSource && image.dataset.productCardAlphaCropSource !== sourceUrl) return;
          image.dataset.productCardAlphaCropFailed = 'true';
          image.dataset.productCardReady = 'true';
        };
        probe.src = sourceUrl;
      }

      if (image.complete) cropImage();
      else image.addEventListener('load', cropImage, { once: true });
    });
  }

  // Fifteen-serving PLPB bags use square source files with substantial alpha
  // padding. Re-run the crop whenever their selected variant image changes so
  // the visible package, rather than the 1:1 canvas, controls card sizing.
  function prepareAlphaCroppedCardImage(image, sourceUrl) {
    var shouldCrop = image.classList.contains('ae--product-card-image--alpha-crop');
    var previousObjectUrl = image.dataset.productCardAlphaCropUrl;

    if (!shouldCrop) {
      if (previousObjectUrl) URL.revokeObjectURL(previousObjectUrl);
      delete image.dataset.productCardAlphaCropUrl;
      delete image.dataset.productCardAlphaCropSource;
      delete image.dataset.productCardAlphaCropBound;
      delete image.dataset.productCardAlphaCropped;
      delete image.dataset.productCardAlphaCropFailed;
      return;
    }

    if (image.dataset.productCardAlphaCropSource === sourceUrl &&
        (image.dataset.productCardAlphaCropped === 'true' || image.dataset.productCardAlphaCropBound === 'true')) return;

    if (previousObjectUrl) URL.revokeObjectURL(previousObjectUrl);
    image.dataset.productCardAlphaCropSource = sourceUrl;
    delete image.dataset.productCardAlphaCropUrl;
    delete image.dataset.productCardAlphaCropBound;
    delete image.dataset.productCardAlphaCropped;
    delete image.dataset.productCardAlphaCropFailed;
    initAlphaCroppedCardImages(image);
  }

  function updateLinks(card, root, variant) {
    var url = root.dataset.productUrl;
    var defaultVariantId = root.dataset.defaultVariantId;

    // The default product state has a canonical handle-only URL. Preserve a
    // variant query only after the card resolves to a different variant so the
    // PDP can open the size or option the customer deliberately selected.
    if (defaultVariantId && String(variant.id) !== String(defaultVariantId)) {
      url += '?variant=' + encodeURIComponent(variant.id);
    }

    card.querySelectorAll('a[href]').forEach(function (link) {
      link.href = url;
    });
    card.querySelectorAll('.js-go-to-pdp[data-url]').forEach(function (button) {
      button.dataset.url = url;
    });
  }

  function updateForm(card, variant) {
    var form = card.querySelector('form[action="/cart/add"]');
    if (!form) return;

    var variantInput = form.querySelector('.product-variant-id[name="id"]');
    var quantityInput = form.querySelector('input[name="quantity"]');
    var addButton = form.querySelector('.js-go-cart-add-to-cart');
    var unavailable = form.querySelector('[data-variant-unavailable]');
    var quantityControl = form.querySelector('.ae--qty-control');
    var variantChanged = variantInput && String(variantInput.value) !== String(variant.id);
    var minimum = Number(variant.quantityMinimum) || 1;
    var increment = Number(variant.quantityIncrement) || 1;
    var maximum = variant.quantityMaximum == null ? null : Math.max(0, Number(variant.quantityMaximum));

    if (variantInput) variantInput.value = variant.id;
    if (quantityInput) {
      quantityInput.min = minimum;
      quantityInput.value = minimum;
      quantityInput.dataset.qtyIncrement = increment;
      if (maximum == null || !Number.isFinite(maximum)) {
        quantityInput.removeAttribute('max');
        delete quantityInput.dataset.qtyMax;
      } else {
        quantityInput.max = maximum;
        quantityInput.dataset.qtyMax = maximum;
      }
    }
    if (addButton) {
      addButton.dataset.variantId = variant.id;
      addButton.hidden = !variant.available;
      addButton.disabled = !variant.available;
    }
    if (quantityControl && !variant.available) quantityControl.style.display = 'none';
    if (unavailable) {
      unavailable.dataset.variantId = variant.id;
      unavailable.dataset.cseVariant = variant.id;
      unavailable.hidden = !addButton || variant.available;
    }
    if (variantChanged) variantInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function updateAvailability(root, variants, selectedOptions) {
    root.querySelectorAll('[data-option-index]').forEach(function (group) {
      var optionIndex = Number(group.dataset.optionIndex);

      group.querySelectorAll('[data-option-value]').forEach(function (button) {
        var possible = variants.some(function (variant) {
          if (!variant.available || variant.options[optionIndex] !== button.dataset.optionValue) return false;

          return selectedOptions.every(function (selectedValue, index) {
            return index === optionIndex || variant.options[index] === selectedValue;
          });
        });

        button.classList.toggle('is-unavailable', !possible);
        button.setAttribute('aria-disabled', possible ? 'false' : 'true');
        if (possible) button.removeAttribute('data-option-sold-out');
      });

      var select = group.querySelector('[data-option-select]');
      if (select) {
        Array.from(select.options).forEach(function (option) {
          option.disabled = !variants.some(function (variant) {
            if (!variant.available || variant.options[optionIndex] !== option.value) return false;

            return selectedOptions.every(function (selectedValue, index) {
              return index === optionIndex || variant.options[index] === selectedValue;
            });
          });
        });
      }
    });
  }

  function getActiveVariantFilters(root) {
    // Not cached: #productGridContainer survives AJAX filter updates (only its
    // innerHTML is swapped), so a cached value here would go stale.
    var container = root.closest('#productGridContainer') || document;
    var data = container.querySelector('[data-active-variant-filters]');
    var filters = {};

    if (data) {
      try {
        var parsed = JSON.parse(data.textContent);
        Object.keys(parsed).forEach(function (key) {
          filters[key] = new Set(parsed[key]);
        });
      } catch (error) {
        filters = {};
      }
    }

    return filters;
  }

  // Hides variant-option choices that don't match the collection's active filters
  // (e.g. a "Servings" filter should hide pack sizes the shopper didn't ask for).
  // Falls back to showing everything if hiding would leave a group with no options.
  function applyOptionFilters(root) {
    var filters = getActiveVariantFilters(root);
    if (!Object.keys(filters).length) return;

    root.querySelectorAll('[data-option-index]').forEach(function (group) {
      var optionName = group.dataset.optionName;
      var activeValues = optionName && filters[optionName];
      if (!activeValues || !activeValues.size) return;

      var pills = Array.from(group.querySelectorAll('[data-option-value]'));
      var options = Array.from(group.querySelectorAll('option'));
      var choices = pills.length ? pills : options;
      if (!choices.length) return;

      var matching = choices.filter(function (choice) {
        return activeValues.has(choice.dataset.optionValue || choice.value);
      });
      if (!matching.length) return;

      choices.forEach(function (choice) {
        choice.hidden = matching.indexOf(choice) === -1;
      });
    });
  }

  // If the option's current selection got hidden by applyOptionFilters, move
  // the selection to the first still-visible choice in that group.
  function reconcileHiddenSelection(root, options) {
    var next = options.slice();

    root.querySelectorAll('[data-option-index]').forEach(function (group) {
      var index = Number(group.dataset.optionIndex);
      var selectedPill = group.querySelector('[data-option-value][aria-pressed="true"]');
      if (selectedPill && !selectedPill.hidden) return;

      var visiblePill = group.querySelector('[data-option-value]:not([hidden])');
      if (visiblePill) {
        next[index] = visiblePill.dataset.optionValue;
        return;
      }

      var select = group.querySelector('[data-option-select]');
      var visibleOption = select && select.querySelector('option:not([hidden])');
      if (visibleOption) next[index] = visibleOption.value;
    });

    return next;
  }

  function applyVariant(root, variant) {
    if (!variant) return;

    var card = root.closest('.ae--product-card');
    if (!card) return;

    // Keep the EA auto-badge variant scope in sync with the selected variant.
    card.dataset.eaVariantId = variant.id;

    setSelectedOptions(root, variant.options);
    var selectedServingTone = getServingToneFromOptions(variant.options, root);
    updateAvailability(root, parseVariants(root), variant.options);
    updatePrice(card, root, variant);
    updateDiscountBadge(card, variant);
    updateImage(card, variant, function () {
      card.dataset.selectedServingTone = selectedServingTone;
    });
    updateLinks(card, root, variant);
    updateForm(card, variant);

    card.classList.toggle('ae--product-card--selected-sold-out', !variant.available);
    root.dispatchEvent(new CustomEvent('product-card:variant-change', {
      bubbles: true,
      detail: { variant: variant }
    }));
  }

  // Center the selected pill by scrolling only its pill row. When the row
  // overflows, the temporary edge space lets the first and last pills reach
  // the center instead of being clamped against an edge.
  function centerSelectedPill(root, behavior) {
    var rows = root.querySelectorAll('.ae--product-card-selector__pills');
    Array.prototype.forEach.call(rows, function (row) {
      row.style.setProperty('--ae-selector-edge-space', '0px');
      if (row.scrollWidth <= row.clientWidth) {
        row.scrollLeft = 0;
        return;
      }

      var selected = row.querySelector('.is-selected');
      if (!selected) return;

      var rowStyles = window.getComputedStyle(row);
      var inlinePadding = parseFloat(rowStyles.paddingLeft) || 0;
      var edgeSpace = Math.max(0, (row.clientWidth - selected.offsetWidth) / 2 - inlinePadding);
      row.style.setProperty('--ae-selector-edge-space', edgeSpace + 'px');

      var left = selected.offsetLeft - (row.clientWidth - selected.offsetWidth) / 2;
      row.scrollTo({ left: left, behavior: behavior || 'auto' });
    });
  }

  function initializeRoot(root) {
    if (root.dataset.variantSelectorInitialized === 'true') return;

    applyOptionFilters(root);
    var options = reconcileHiddenSelection(root, getSelectedOptions(root));
    var variant = findVariant(parseVariants(root), options);
    if (!variant) return;

    root.dataset.variantSelectorInitialized = 'true';
    applyVariant(root, variant);
    // Defer to next frame so pill widths are laid out before centering.
    requestAnimationFrame(function () { centerSelectedPill(root, 'auto'); });
  }

  function initializeSelectors(scope) {
    if (scope.matches && scope.matches(selectorRoot)) initializeRoot(scope);
    if (scope.querySelectorAll) scope.querySelectorAll(selectorRoot).forEach(initializeRoot);
  }

  function handleChange(control) {
    var root = control.closest(selectorRoot);
    if (!root) return;

    var variants = parseVariants(root);
    var group = control.closest('[data-option-index]');
    var changedIndex = Number(group.dataset.optionIndex);
    var changedValue = control.dataset.optionValue || control.value;

    if (control.matches('[data-option-value]')) {
      group.querySelectorAll('[data-option-value]').forEach(function (button) {
        var selected = button === control;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    }

    var options = getSelectedOptions(root);
    var variant = findVariant(variants, options) || findFallbackVariant(variants, changedIndex, changedValue);
    applyVariant(root, variant);
    requestAnimationFrame(function () { centerSelectedPill(root, 'smooth'); });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-product-card-selector] [data-option-value]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    handleChange(button);
  }, true);

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-product-card-selector] [data-option-select]');
    if (!select) return;

    event.preventDefault();
    event.stopPropagation();
    handleChange(select);
  }, true);

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-product-card-selector]')) {
      event.preventDefault();
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    initializeSelectors(document);
    initProductImages(document);
    initAlphaCroppedCardImages(document);
  });

  document.addEventListener('FiltersUpdated', function () {
    initializeSelectors(document);
    initProductImages(document);
    initAlphaCroppedCardImages(document);
  });

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          initializeSelectors(node);
          initProductImages(node);
          initAlphaCroppedCardImages(node);
        }
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
